export default __webpack_public_path__ + "static/media/united.7fca2341.png";